module.exports = __webpack_public_path__ + "assets/img/tx102s.c5df3724.jpg";